'use client';

import React from 'react'
import { Button } from './ui/button';
import { LocaleConstants } from '@/lib/react/i18n/constants/LocaleConstants';
import { useTranslation } from '@/lib/react/i18n';
import { LocaleApi } from '@/restapi/locale';
import { useSession } from 'next-auth/react';
import { useRouter, usePathname } from 'next/navigation';

type CustomComponentProps = React.ComponentProps<'div'> & {
	customProp?: string;
}

const JpButton: React.FC<CustomComponentProps> = ({ customProp, className, style, ...props }) => {
	const { setLocale, locale, t } = useTranslation();
	const { data: session } = useSession();
	const user = session?.user;
	const router = useRouter();
	const pathname = usePathname();

	const clickJp = async () => {
		setLocale('ja');
		document.cookie = `${LocaleConstants.COOKIE_KEY}=ja; path=/; max-age=31536000; SameSite=Lax`;
		
		// cookie の更新後、router.refresh() で server component (generateMetadata含む) を再実行
		await new Promise(resolve => setTimeout(resolve, 100));
		router.refresh();

		try {
			if (user) {
				await LocaleApi.changeLanguage({ locale: 'ja', userId: user.id, });
			}
		} catch (error: any) {
			alert(t('Language change failed'));
		}
	}

	return (
		<Button
			data-testid="jp-language-button"
			className={className}
			style={locale === 'ja'
				? {
					backgroundColor: 'rgb(209 213 219 / var(--tw-bg-opacity))',
					color: '#000'
				}
				: {
					backgroundColor: 'rgb(100 100 100 / var(--tw-bg-opacity))',
					color: '#ffffff'
				}
			}
			onClick={clickJp}>JP</Button>
	)
}

export default JpButton
